/* Restaurant Halong 2026-10-09 (M-2): Fenster für Gerichte und Woks per Tastatur bedienbar.
   Beim Öffnen wird das Fenster als Dialog ausgezeichnet und der Fokus auf die erste Auswahl des aktiven Schritts gesetzt.
   Tab bleibt im Fenster, Escape schließt, nach „Weiter“/„Zurück“ springt der Fokus in den neuen Schritt.
   Nach dem Schließen geht der Fokus an den Auslöser zurück; ist danach der Warenkorb offen, geht er in den Warenkorb
   und nach dem Schließen des Warenkorbs wieder an den Auslöser.
   09.10. abends: Mit Maus oder Finger geöffnet bekommt die Fläche selbst den Fokus statt der ersten Auswahl,
   damit kein Fokusring wie eine Vorauswahl aussieht (Chrome zeigt den Ring sonst nach Escape und erneutem Klick, gemessen 09.10.). */
(function () {
  var FOKUSSIERBAR = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var ausloeser = null;
  var letzterKlick = null;
  var zurueckNachWarenkorb = null;
  var perZeiger = false; // letzte Bedienung mit Maus oder Finger

  function aktivesFenster() { return document.querySelector('.popup.activePopup'); }

  function sichtbar(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) && getComputedStyle(el).visibility !== 'hidden';
  }

  function fokussierbare(fenster) {
    return [].slice.call(fenster.querySelectorAll(FOKUSSIERBAR)).filter(sichtbar);
  }

  function auszeichnen(fenster) {
    if (fenster.hasAttribute('data-hk-dialog')) return;
    fenster.setAttribute('data-hk-dialog', '');
    fenster.setAttribute('role', 'dialog');
    fenster.setAttribute('aria-modal', 'true');
    var kopf = fenster.querySelector('.stepsFormHeader, .popup-inner h2, .popup-inner h3, .popup-inner .product-card__title');
    if (kopf) {
      if (!kopf.id) kopf.id = 'hk-fenster-' + (fenster.getAttribute('data-popup') || Math.random().toString(36).slice(2, 8));
      fenster.setAttribute('aria-labelledby', kopf.id);
    }
    fenster.querySelectorAll('.popup-close').forEach(function (a) {
      a.setAttribute('role', 'button');
      a.setAttribute('aria-label', 'Fenster schließen');
    });
  }

  function fokusInSchritt(fenster) {
    if (perZeiger) {
      var flaeche = fenster.querySelector('.popup-inner') || fenster;
      if (!flaeche.hasAttribute('tabindex')) flaeche.setAttribute('tabindex', '-1');
      flaeche.focus({ preventScroll: true });
      return;
    }
    var schritt = fenster.querySelector('.step.active') || fenster;
    var ziel = schritt.querySelector('input[type="radio"]:checked') || schritt.querySelector('input[type="radio"]');
    if (!ziel || !sichtbar(ziel)) ziel = fokussierbare(schritt)[0] || fokussierbare(fenster)[0];
    if (ziel) ziel.focus({ preventScroll: true });
  }

  function geoeffnet(fenster) {
    var vorher = document.activeElement;
    ausloeser = vorher && vorher !== document.body && !fenster.contains(vorher) ? vorher : letzterKlick;
    auszeichnen(fenster);
    fokusInSchritt(fenster);
  }

  // Offener Drawer oder Dialog außerhalb der Gericht-Fenster (z. B. Warenkorb nach „Hinzufügen“).
  function offenerDialog() {
    return [].slice.call(document.querySelectorAll('[role="dialog"][open], dialog[open]')).filter(function (d) {
      return !d.classList.contains('popup') && sichtbar(d);
    })[0] || null;
  }

  function fokusInDialog(dialog) {
    var jetzt = document.activeElement;
    if (jetzt && dialog.contains(jetzt)) return true;
    var ziel = fokussierbare(dialog)[0];
    if (!ziel) return false;
    ziel.focus({ preventScroll: true });
    return true;
  }

  function geschlossen(fenster) {
    var ziel = ausloeser;
    setTimeout(function () {
      var dialog = offenerDialog();
      if (dialog) { if (fokusInDialog(dialog)) zurueckNachWarenkorb = ziel; return; }
      var jetzt = document.activeElement;
      var verloren = !jetzt || jetzt === document.body || fenster.contains(jetzt);
      if (verloren && ziel && document.contains(ziel) && sichtbar(ziel)) ziel.focus({ preventScroll: true });
    }, 400);
  }

  function beobachten() {
    var beobachter = new MutationObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        var war = (e.oldValue || '').split(/\s+/).indexOf('activePopup') !== -1;
        var ist = e.target.classList.contains('activePopup');
        if (!war && ist) geoeffnet(e.target);
        if (war && !ist) geschlossen(e.target);
      });
    });
    document.querySelectorAll('.popup').forEach(function (fenster) {
      beobachter.observe(fenster, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    });
    // Öffnet sich der Warenkorb erst nach dem Schließen des Fensters (Antwort von /cart/add), Fokus nachziehen,
    // wenn er noch hinter dem Drawer auf der Seite liegt.
    // Beobachtet wird das ganze Dokument, weil der Drawer beim Aktualisieren des Warenkorbs neu gerendert werden kann.
    new MutationObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        var warenkorb = e.target;
        if (warenkorb.tagName !== 'CART-DRAWER') return;
        if (!warenkorb.hasAttribute('open')) {
          // Warenkorb zu: Fokus zurück an das „+“, von dem aus er geöffnet wurde, statt an den Seitenanfang.
          var ziel = zurueckNachWarenkorb;
          zurueckNachWarenkorb = null;
          if (!ziel) return;
          setTimeout(function () {
            var jetzt = document.activeElement;
            var verloren = !jetzt || jetzt === document.body || warenkorb.contains(jetzt);
            if (verloren && document.contains(ziel) && sichtbar(ziel)) ziel.focus({ preventScroll: true });
          }, 300);
          return;
        }
        // Der Drawer blendet sich animiert ein; bis zu sechsmal nachsehen, ob seine Knöpfe schon sichtbar sind.
        var versuche = 0;
        function pruefen() {
          versuche += 1;
          var jetzt = document.activeElement;
          if (!warenkorb.hasAttribute('open') || !jetzt || warenkorb.contains(jetzt)) return;
          // Fokus liegt noch auf der Seite, auf dem Auslöser oder im gerade geschlossenen Fenster.
          var aufSeite = jetzt === document.body || jetzt.matches('.halong-add, [data-popup-open]') || !!jetzt.closest('.popup:not(.activePopup)');
          if (!aktivesFenster() && aufSeite && fokusInDialog(warenkorb)) { zurueckNachWarenkorb = ausloeser; return; }
          if (versuche < 6) setTimeout(pruefen, 250);
        }
        setTimeout(pruefen, 250);
      });
    }).observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
  }

  document.addEventListener('pointerdown', function () { perZeiger = true; }, true);
  document.addEventListener('keydown', function () { perZeiger = false; }, true);

  document.addEventListener('click', function (e) {
    var ziel = e.target && e.target.closest ? e.target.closest('[data-popup-open], [data-halong-open], .halong-add') : null;
    if (ziel) letzterKlick = ziel;
    var fenster = aktivesFenster();
    if (fenster && e.target.closest && e.target.closest('.next, .prev')) {
      setTimeout(function () {
        var jetzt = document.activeElement;
        if (!jetzt || jetzt === document.body || !sichtbar(jetzt)) fokusInSchritt(fenster);
      }, 30);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    var fenster = aktivesFenster();
    if (!fenster) return;
    if (e.key === 'Escape') {
      var schliessen = fenster.querySelector('.popup-close');
      if (schliessen) { e.preventDefault(); schliessen.click(); }
      return;
    }
    if ((e.key === ' ' || e.key === 'Spacebar') && e.target.matches && e.target.matches('a[role="button"]')) {
      e.preventDefault();
      e.target.click();
      return;
    }
    if (e.key !== 'Tab') return;
    var liste = fokussierbare(fenster);
    if (!liste.length) return;
    var erstes = liste[0];
    var letztes = liste[liste.length - 1];
    var jetzt = document.activeElement;
    // Fokus außerhalb oder auf der Fläche selbst (nach Öffnen per Maus): Tab beginnt bei der ersten, Umschalt+Tab bei der letzten Stelle.
    if (!fenster.contains(jetzt) || liste.indexOf(jetzt) === -1) { e.preventDefault(); (e.shiftKey ? letztes : erstes).focus(); return; }
    if (e.shiftKey && jetzt === erstes) { e.preventDefault(); letztes.focus(); }
    else if (!e.shiftKey && jetzt === letztes) { e.preventDefault(); erstes.focus(); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beobachten);
  else beobachten();
})();
